// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"751de1ce","313":"3ec81e6d","453":"4115fed6"}[chunkId] + ".chunk.js";
};